import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { RssEntry, RssFeedImage } from '../../../services/betting';
import { LoadingIndicatorSpinner } from '../LoadingIndicatorSpinner';
import { portletLoad } from './actions';
import { portletEntriesSelector } from './selectors';

interface Props {
    porletName: string;
}

export const RssPortlet: FC<Props> = props => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(portletLoad(props.porletName));
    }, [dispatch, props.porletName]);

    const feed = useSelector(portletEntriesSelector(props.porletName));

    const renderImage = (image: RssFeedImage, index: number) => {
        return (
            <img
                key={index}
                className="img-fluid"
                src={image.url}
                alt={image.altText}
                height={image.height}
                width={image.width}
            />
        );
    };

    const renderEntry = (entry: RssEntry, index: number) => {
        const description = entry.description
            ? entry.description.length > 150
                ? entry.description.substr(0, 150)
                : entry.description
            : '';
        return (
            <Col sm={4} key={index} className="bg-light pe-1" >
                <div className="w-100 h-100 bg-white p-3">
                    <div>
                        <span
                            className="text-primary"
                            style={{ fontSize: '11px' }}
                            dangerouslySetInnerHTML={{ __html: entry.topLine || '' }}
                        />
                        <h5
                            style={{ fontWeight: 'bold', minHeight: '3rem' }}
                            dangerouslySetInnerHTML={{ __html: entry.title || '' }}
                        />
                        <span dangerouslySetInnerHTML={{ __html: entry.shortTitle || '&nbsp;' }} />
                    </div>
                    <div className="">
                        <a href={entry.link} title={entry.title} className="pe-2 float-left">
                            <img src={entry.image} alt={entry.title} width={80} className="py-2" />
                        </a>
                        {entry.images && entry.images.map((i, index) => renderImage(i, index))}

                        <span>
                            <span dangerouslySetInnerHTML={{ __html: description }} />
                            ...
                            <a href={entry.link} title={entry.title}>
                                [mehr]
                            </a>
                        </span>
                    </div>
                </div>
            </Col>
        );
    };

    if (feed) {
        return (
            <>
                <div className="p-0 bg-light container-fluid">
                    <Row className="p-0 pe-1">{feed.entries && feed.entries.slice(0,3).map((e, index) => renderEntry(e, index))}</Row>
                    <Row className="pt-3 pe-1">{feed.entries && feed.entries.slice(3,6).map((e, index) => renderEntry(e, index))}</Row>
                </div>
            </>
        );
    } else {
        return <LoadingIndicatorSpinner />;
    }
};
